import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IDataSourceBase } from '../models/IDataSourceInfo';
import { DataSources } from '../resources/Datasources';

export namespace ChangeDatasourceCertificationAction {
  export function execute(datasource: IDataSourceBase, certification: { certificationNote: string, isCertified: boolean }): Promise<IResult> {
    return DataSources.setCertification({
      id: datasource.id,
      luid: datasource.luid,
      isCertified: certification.isCertified,
      certificationNote: certification.certificationNote,
    });
  }
}

export type ChangeDatasourceCertificationAction = typeof ChangeDatasourceCertificationAction;